import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LoansState {
  searchText: string;
  selectedPeriod: string;
  page: number;
  rowsPerPage: number;
}

const initialState: LoansState = {
  searchText: '',
  selectedPeriod: 'This Week',
  page: 0,
  rowsPerPage: 10,
};

const loansSlice = createSlice({
  name: 'loans',
  initialState,
  reducers: {
    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
      state.page = 0; // Reset to first page on search
    },
    setSelectedPeriod: (state, action: PayloadAction<string>) => {
      state.selectedPeriod = action.payload;
    },
    setPage: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action: PayloadAction<number>) => {
      state.rowsPerPage = action.payload;
      state.page = 0; // Reset to first page on rows per page change
    },
  },
});
export const { setSearchText, setSelectedPeriod, setPage, setRowsPerPage } =
  loansSlice.actions;
export default loansSlice.reducer;
